export enum FinpowerXmlOption {
  ACCOUNT = "ACCOUNT",
}

export interface SubmitToLMSRequest {
  assessmentId: string;
  xmlOption: FinpowerXmlOption;
}
